import { render } from "./MyShoppingOrders.vue?vue&type=template&id=794d4e68"
import script from "./MyShoppingOrders.vue?vue&type=script&lang=js"
export * from "./MyShoppingOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__